module.exports = __webpack_public_path__ + "static/media/CM-marca_reduzida-positiva-RGB.e2eb8684.svg";